import { TextField } from '@mui/material';
import React from 'react';
import { SearchLightIcon } from 'src/icons';
import debounce from 'src/utils/Debounce';

interface SearchProps {
  placeholder?: string;
  onChange: (value: string) => void;
}

const Search = function Search(props: SearchProps) {
  const { placeholder, onChange } = props;
  const debouncedSearch = debounce(onChange, 500);
  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(event.target.value);
  };

  return (
    <TextField
      id="input-with-icon-textfield"
      label=""
      className="rounded-3xl "
      fullWidth
      placeholder={placeholder}
      onChange={handleValueChange}
      sx={{
        '& fieldset': { border: 'none' },
        ':root': { borderRadius: '30px' },
      }}
      InputProps={{
        startAdornment: (<SearchLightIcon className="mr-[12px]" />),
        style: { borderRadius: '30px' },
        className: 'custom-shadow',
      }}
      variant="outlined"
    />
  );
};

Search.defaultProps = {
  placeholder: '',
};

Search.propTypes = {

};

export default Search;
